// extracted by mini-css-extract-plugin
export var actionButton = "_i2-0";
export var fileInput = "_i2-2";
export var paperclip = "_i2-1";